module.exports = __webpack_public_path__ + "static/media/21.a6010064.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/21.png
// module id = 1062
// module chunks = 0